import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=219dadf1&scoped=true&"
import script from "./Instagram.vue?vue&type=script&lang=js&"
export * from "./Instagram.vue?vue&type=script&lang=js&"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=219dadf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219dadf1",
  null
  
)

export default component.exports